const Enums = {
    CheckOutRequestType: {
        Approve: 0,
        Reject: 1,
        Checkout: 2
    },
    NoYes: {
        No: 0,
        Yes: 1
    },
    SiteNavLevel: {
        DealerConfig: 0,
        SiteConfig: 1,
        GroupConfig: 2,
        UserConfigCookie: 3,
        UserConfigLoggedIn: 4
    },
    PaymentMethod: {
        None: 0,
        CreditCard: 1,
        Check: 2,
        Agency: 3,
        Prepayment: 4,
        ACH: 5,
        name: {
            0: "None",
            1: "Credit Card",
            2: "Agency",
            4: "Prepayment",
            5: "ACH"
        }
    },
    BankAccountType: {
        None: 0,
        BusinessChecking: 10,
        PersonalChecking: 20,
        name: {
            0: "None",
            10: "Business Checking",
            20: "Personal Checking"
        }
    },
    PaymentFrequency: {
        Daily: 0,
        Weekly: 10,
        BiMonthly: 20,
        Monthly: 40,
        name: {
            0: "Daily",
            10: "Weekly",
            20: "Bi-Monthly - 15th/EOM",
            40: "Monthly"
        }
    },
    CreditCardType: {
        None: 0,
        Visa: 1,
        Mastercard: 2,
        AmericanExpress: 3,
        Discover: 4,
        //DinersClub: 5,
        //JCB: 6,
        name: {
            0: "None",
            1: "Visa",
            2: "Mastercard",
            3: "American Express",
            4: "Discover",
            //5: "Diner's Club",
            //6: "JCB"
        }
    },
    WeekDays: {
        None: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
        Sunday: 7,
        name: {
            0: "None",
            1: "Monday",
            2: "Tuesday",
            3: "Wednesday",
            4: "Thursday",
            5: "Friday",
            6: "Saturday",
            7: "Sunday"
        }
    },
    DayOfMonth: {
        Last: 0,
        One: 1,
        Two: 2,
        Three: 3,
        Four: 4,
        Five: 5,
        Six: 6,
        Seven: 7,
        Eight: 8,
        Nine: 9,
        Ten: 10,
        Eleven: 11,
        Twelve: 12,
        Thirteen: 13,
        Fourteen: 14,
        Fifteen: 15,
        Sixteen: 16,
        Seventeen: 17,
        Eighteen: 18,
        Nineteen: 19,
        Twenty: 20,
        TwentyOne: 21,
        TwentyTwo: 22,
        TwentyThree: 23,
        TwentyFour: 24,
        TwentyFive: 25,
        TwentySix: 26,
        TwentySeven: 27,
        TwentyEight: 28,
        TwentyNine: 29,
        Thirty: 30,
        name: {
            0: "31st/Last",
            1: "1st",
            2: "2nd",
            3: "3rd",
            4: "4th",
            5: "5th",
            6: "6th",
            7: "7th",
            8: "8th",
            9: "9th",
            10: "10th",
            11: "11th",
            12: "12th",
            13: "13th",
            14: "14th",
            15: "15th",
            16: "16th",
            17: "17th",
            18: "18th",
            19: "19th",
            20: "20th",
            21: "21st",
            22: "22nd",
            23: "23rd",
            24: "24th",
            25: "25th",
            26: "26th",
            27: "27th",
            28: "28th",
            29: "29th",
            30: "30th"
        }
    }
};
export default Enums;